// Установка как приложение и обновление service worker.
import { usePwa } from '@/composables/usePwa';

export function installPwa(): void {
  const { installEvent, updateReady } = usePwa();
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return;
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    installEvent.value = event as unknown as { prompt: () => Promise<void> };
  });
  navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(registration => {
    registration.onupdatefound = () => {
      const worker = registration.installing;
      if (!worker) return;
      worker.onstatechange = () => {
        if (worker.state === 'installed' && navigator.serviceWorker.controller) updateReady.value = true;
      };
    };
  }).catch(() => undefined);
  navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload());
}
